import createReducer from 'common/redux/utils/createReducer';
import { Map } from 'immutable';
import keyBy from 'lodash.keyby';
import {
  REQUEST_RECIPIENTS,
  RECEIVE_RECIPIENTS,
  FILTER_RECIPIENTS,
} from 'messaging/actions/recipient';

const initialState = {
  isFetching: false,
  didInvalidate: false,
  loaded: false,
  items: Map(),
};

const recipients = createReducer(initialState, {
  [REQUEST_RECIPIENTS](state, action) {
    return {
      isFetching: true,
      ...state,
    };
  },
  [RECEIVE_RECIPIENTS](state, { recipients }) {
    return {
      ...state,
      isFetching: false,
      loaded: true,
      items: Map(keyBy(recipients, 'id')),
    };
  },
  [FILTER_RECIPIENTS](state, { filter }) {
    if (filter.trim().length) {
      const filtered = state.items.filter(r => {
        return (
          r.name && r.name.toLowerCase().indexOf(filter.toLowerCase()) > -1
        );
      });

      return {
        ...state,
        filtered,
      };
    } else {
      return {
        ...state,
        filtered: undefined,
      };
    }
  },
});

export default recipients;



// WEBPACK FOOTER //
// ./src/modules/messaging/reducers/recipients.js